import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, React } from 'react';
import { Utils } from '../../Utils';
import { useAppContext, useModalsContext } from '../../contexts/AppContext';

import AppHeader from "../../components/AppHeader/AppHeader.js";
import AppFooterMenu from "../../components/AppFooterMenu/AppFooterMenu.js";
import PopupOffline from '../../components/PopupOffline/PopupOffline';
import PopupContent from '../../components/PopupContent/PopupContent';

import PopupAddedToCart from '../../components/PopupAddedToCart/PopupAddedToCart';
import ShoppingCart from "../../components/ShoppingCart/ShoppingCart";
import ProductsMenu from "../../components/ProductsMenu/ProductsMenu.js";
import ProfileMenu from "../../components/ProfileMenu/ProfileMenu.js";
import MyOrders from "../../components/MyOrders/MyOrders.js";
import MyMessages from "../../components/MyMessages/MyMessages.js";
import Wishlist from "../../components/Wishlist/Wishlist.js";
import Profile from "../../components/Profile/Profile.js";
import Shops from "../../components/Shops/Shops.js";
//import ProfilePaymentMethod from "../../components/ProfilePaymentMethod/ProfilePaymentMethod.js";
import ProfileBillAddress from "../../components/ProfileBillAddress/ProfileBillAddress.js";
import ProfileDeliveryAddresses from "../../components/ProfileDeliveryAddresses/ProfileDeliveryAddresses.js";
import ProfilePersonalDatas from "../../components/ProfilePersonalDatas/ProfilePersonalDatas.js";
import SignIn from "../SignIn/SignIn.js";

const Layout = (props) => {
  const navigate = useNavigate();
  
  // Context-ek használata
  const { appRef } = useAppContext();
  const modalsContext = useModalsContext();

   // Kontextusok használata a komponensekben
  // const { AppHeaderRef, AppFooterMenuRef } = useAppContext();
  const { AppHeaderRef, AppFooterMenuRef } = modalsContext;

  // A useEffect egy React Hook, amely lehetővé teszi az összetevők külső rendszerrel való szinkronizálását.
  useEffect(() => {

    // data-type nélküli linkek (azok aamelyek nem areacttal lettek előállítva) lekezelése
    // target="_blank" url-el csak akkor enged ablakot nyitni ha a href-ben szerepel a ://

    window.onclick = function (e) {
      const linkElement = e.target?.closest ? e.target.closest('a') : null;

      if (linkElement && !linkElement.dataset.type) 
      {
        let href = (linkElement.getAttribute('href') || '').trim();
        let target = linkElement.getAttribute('target');
        let popup = linkElement.getAttribute('data-popup');

        if (!href) {
          return;
        }

        if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
          e.preventDefault();
          Utils.openExternalUrl(href);
          return;
        }

        if (target === '_blank' && href.indexOf('://') !== -1) {
          e.preventDefault();
          Utils.openExternalUrl(href);
          return;
        }

        if (parseInt(popup) === 1 && href.indexOf('://') === -1)
        {
          e.preventDefault(); 

          Utils.get_server_data(
            '/content/' + href, 
            {ajax_event: 'content', APICACHE: 'false'}, 
            {}
          ).then(res => {
            // Használhatjuk a kontextusban lévő referenciát
            modalsContext.PopupContentRef.current.show(res);
          }); 
          
        }
        else if (!target || href.indexOf('://') === -1)
        {
          e.preventDefault(); 

          Utils.get_url_data(href).then(res => {
            navigate('/' + res.url_type + '/' + href);
          });
        }
      }
    }
      
  }, []); 

 
  return (<> 
      <AppHeader ref={AppHeaderRef} />
      {appRef.current && appRef.current.is_online() ? '' : <PopupOffline />}
      <Outlet />

      <PopupContent ref={modalsContext.PopupContentRef} />
      <PopupAddedToCart ref={modalsContext.PopupAddedToCartRef} />
      <ShoppingCart ref={modalsContext.ShoppingCartRef} />
      <ProductsMenu ref={modalsContext.ProductsMenuRef} />
      <ProfileMenu ref={modalsContext.ProfileMenuRef} />
      <Shops ref={modalsContext.ShopsRef} />
      <SignIn ref={modalsContext.SignInRef} />

      {appRef.current && appRef.current.get_is_signed() ? <>
        <MyOrders ref={modalsContext.MyOrdersRef} />
        <MyOrders ref={modalsContext.MyOrdersRef_2} />
        <MyMessages ref={modalsContext.MyMessagesRef} />
        <MyMessages ref={modalsContext.MyMessagesRef_2} />
        <Profile ref={modalsContext.ProfileRef} />
        {/*<ProfilePaymentMethod ref={modalsContext.ProfilePaymentMethodRef} />*/}
        <ProfileBillAddress ref={modalsContext.ProfileBillAddressRef} />
        <ProfilePersonalDatas ref={modalsContext.ProfilePersonalDatasRef} />
        <ProfileDeliveryAddresses ref={modalsContext.ProfileDeliveryAddressesRef} />
      </> : ''}

      <AppFooterMenu ref={AppFooterMenuRef} />
    </>)
};

export default Layout;